import * as React from "react";
import Box from '@mui/material/Box';
import {Avatar, OutlinedInput, Stack, Typography, Grid, Button, TextField } from '@mui/material';
import DateFormat from '../../components/datepicker/DateFormat';
import {useState, useEffect, useContext} from "react";
import FileUploader from "../upload/FileUploader";
import SendIcon from "@mui/icons-material/Send";
import textInputValidator from "./EventValidator";
import {Event} from "../event/queries/event";
import {useEvents} from "./hooks/useEvent";
import {useRole} from "../userInfo/hooks/useRole";
import AlertDialog from "../dashboard/AlertDialog";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import AvatarProfile from "../dashboard/AvatarProfile";
import moment from 'moment';

const NewEvent = ({communityId}) => {
    const [image, setImage] = useState([]);
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(moment().add(30, 'm').toDate());
    const [dateIsError, setDateIsError] = useState(false);
    const [nameIsError, setNameIsError] = useState(false);
    const [nameHelperText, setNameHelperText] = useState(' ');
    const [placeIsError, setPlaceIsError] = useState(false);
    const [placeHelperText, setPlaceHelperText] = useState(' ');
    const [detailIsError, setDetailIsError] = useState(false);
    const [detailHelperText, setDetailHelperText] = useState(' ');
    const [labelImage, setLabelImage] = useState('+ Ajouter une image');
    const [eventName, setEventName] = useState('');
    const [eventPlace, setEventPlace] = useState('');
    const [eventDetail, setEventDetail] = useState('');
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const {updateEvents} = useEvents();
    const {canPublish} = useRole();
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const {mode} = useDarkMode();

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(dateEnd,dateStart);
        console.log(dateEnd,dateStart);
        console.log(dateEnd<=dateStart);
        dateEnd<=dateStart ? setDateIsError(true): setDateIsError(false);
        textInputValidator(eventName, setNameIsError, setNameHelperText);
        textInputValidator(eventPlace, setPlaceIsError, setPlaceHelperText);
        textInputValidator(eventDetail, setDetailIsError, setDetailHelperText);
        console.log(dateIsError);
        if (!nameIsError && !placeIsError && !detailIsError && image.length > 0 && !dateIsError) {
            handleClickOpen();
        }
    }

    const handleAccept = () => {
        const [photo] = image;
        setIsLoading(true);
        Event.sendEvent(eventName, eventPlace, eventDetail, dateStart, dateEnd, photo, communityId)
            .then((response) => {
                if (response === 201) {
                    setEventName('');
                    setEventPlace('');
                    setEventDetail('');
                    setImage([]);
                    setLabelImage('+ Ajouter image');
                    setIsLoading(false);
                    handleClose();
                    //updateEvents();
                }
            }).catch(() => {
            setIsLoading(false);
        })
    }

    useEffect(() => {
        setDateEnd(moment(dateStart).add(30, 'm').toDate())
    },[dateStart])

    return canPublish ?
        <Stack
            component="form"
            onSubmit={handleSubmit}
            sx={{borderRadius: 1, padding: {xs : '20px',md : '20px',lg : '20px'}}}
            style={{backgroundColor: mode.settings.cardBackgroundColor}}
        >
            <AlertDialog
                handleAccept={handleAccept}
                handleClose={handleClose}
                text={'Voulez-vous vraiment publier cet évènement ? '}
                open={open}
                isLoading={isLoading}
            >
            </AlertDialog>
            <Stack spacing={1}>
                <Box>
                    <Grid container spacing={2} alignItems="center">

                        <Grid item xs={12}>
                            <Stack
                                direction="row"
                                justifyContent={{xs : "center", md : "center", lg :"right"}}
                                alignItems="center"
                                spacing={1}
                                flexWrap={"wrap"}
                                gap={1}
                            >
                                <DateFormat
                                    label={"Date de début"}
                                    startDate={dateStart}
                                    setStartDate={setDateStart}
                                ></DateFormat>
                                <DateFormat
                                    label={"Date de fin"}
                                    startDate={dateEnd}
                                    setStartDate={setDateEnd}
                                ></DateFormat>
                            </Stack>
                        </Grid>
                        <Typography sx={{marginLeft:'auto',color:"#d32f2f",fontSize:'0.75rem'}}>
                            {!dateIsError ? ' ':'La date de fin est inférieur à la date de début'}
                        </Typography>
                    </Grid>
                </Box>
                <Stack direction={'row'} spacing={{xs : 0, md : 0, lg : 2}} >
                    <Grid item xs={3} sx={{display : {xs : 'none', md : 'none', lg : 'block'}}}>
                        <div><AvatarProfile size={40} showName={false}/></div>
                    </Grid>
                    <Stack direction={"column"} flexGrow={'inherit'} width={"100%"}>
                        <TextField
                            value={eventName}
                            error={nameIsError}
                            label="Ajouter un évènement"
                            variant="filled"
                            onChange={event => setEventName(event.target.value)}
                            sx={{background :mode.settings.inputBackgroundColor}}
                            InputProps={{ inputProps:{style:{color:mode.settings.textColor3}}}}
                            InputLabelProps={{style:{color:mode.settings.textColor3}}}
                        />
                        <br/>
                        <TextField
                            value={eventPlace}
                            error={placeIsError}
                            label="Ajouter le lieu de l'évènement"
                            variant="filled"
                            onChange={event => setEventPlace(event.target.value)}
                            sx={{background :mode.settings.inputBackgroundColor}}
                            InputProps={{ inputProps:{style:{color:mode.settings.textColor3}}}}
                            InputLabelProps={{style:{color:mode.settings.textColor3}}}
                        />
                        <br/>
                        <TextField
                            value={eventDetail}
                            error={detailIsError}
                            label="Ajouter la description de l'évènement"
                            variant="filled"
                            onChange={event => setEventDetail(event.target.value)}
                            sx={{background :mode.settings.inputBackgroundColor}}
                            InputProps={{ inputProps:{style:{color:mode.settings.textColor3}}}}
                            InputLabelProps={{style:{color:mode.settings.textColor3}}}
                        />
                        <br/>
                        <Stack
                            direction="row"
                            gap={2}
                            alignItems="center"
                            justifyContent="space-between"
                            alignContent="center"
                            marginTop={'10px'}
                            marginTop={'10px'}
                            flexWrap={'wrap'}
                            width={'100%'}
                        >
                            <FileUploader setImageToUpload={setImage} setLabelImage={setLabelImage} labelImage={labelImage} ></FileUploader>
                            <Stack
                                direction="row"
                                justifyContent="right"
                                alignItems="center"
                                spacing={1}
                            >
                                <Button
                                    className='buttonOhs'
                                    startIcon={<SendIcon role="img" aria-label={"Publier l'évènement"}/>}
                                    style={{paddingLeft: 15}}
                                    type="submit"
                                >
                                    <Typography variant={'subtitle3'}>Publier</Typography>
                                </Button>
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack> : <div></div>
}

export default NewEvent;
